import React from "react";
import { GOOGLE_PLAY_URL } from "@/data/content";

// Official "Get it on Google Play" badge, self-hosted in /public/assets.
export default function GooglePlayBadge({ className = "", height = 52, url = GOOGLE_PLAY_URL, label = "Google Play" }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-play-badge"
      className={`inline-block transition-transform hover:-translate-y-0.5 ${className}`}
      aria-label={`Get ${label} on Google Play`}
    >
      <img
        src="/assets/google-play-badge.png"
        alt="Get it on Google Play"
        style={{ height }}
        className="w-auto"
      />
    </a>
  );
}
